<energy-balance [config]="config" [legendAtBottom]="config.legendAtBottom" />
